export class OTSError extends Error {
  errorCode: number;
  constructor(message: string, errorCode: number) {
    super(message);
    this.name = "error.unknown_error";
    this.errorCode = errorCode;
  }
}
